import * as React from 'react';
import * as levels from './style.module.scss';
import dataLevels from "./dataLevels.json";
export const Levels = ({ data=dataLevels }) => {
  return (
    <section className={`${levels.levels} container`}>
      <h2 className={levels.levels__title}>
        Курс развития памяти и внимания:
      </h2>
      <ul className={levels.levels__list}>
        {
          data.map((elem, index) => (
            <li className={levels.levels__item} key={index}>
              <p className={levels.levels__description}>
                <strong>{elem.highlight}</strong> {elem.text}
              </p>
            </li>
          ))
        }
      </ul>
    </section>
  );
};
